import axios from 'axios';
import { getToken } from './loginVerification';

export const deleteInformation = async (id) => {
    const tokenData = await getToken();
    let data;
    if (tokenData.ok) {
        const instance = axios.create({
            headers: { 'Authorization': 'Bearer ' + tokenData.token }
        });
        await instance.delete(`${process.env.REACT_APP_API_HOST}/information/${id}`).then(resp => {
            data = resp.data;
        });
        return data;
    }
};
